<main>
    <div class="container d-flex flex-column justify-content-center align-items-center">
        <div class="container-formulario d-flex flex-column justify-content-center align-items-center">
            <div class="">
                <div class="d-flex flex-column justify-content-center align-items-center">
                    <img class="" src="../../assets/logo-removebg-preview.png">
                    <h2>Redefinir a senha</h2>
                </div>
    
                <p>Digite seu endereço de e-mail  para receber as instruções para redefinir sua senha</p>
            </div>
            <div class="formulario d-flex flex-column justify-content-center align-items-center">
                <form [formGroup]="form"  (ngSubmit)="submit()">
                    <label> 
                        <input class="form-control" formControlName="vc_login" type="email" name="email" id="email" placeholder="ex.: usuario@email.com" >
                    </label>
                    <div class="d-flex justify-content-center">
                        <re-captcha (resolved)="resolved($event)"
                        (error)="errored($event)"
                        errorMode="handled" id="recaptcha" name="recaptcha" required ></re-captcha>
                    </div>
                    <button [disabled]="disable" type="submit" class="btn-sucesso">Enviar</button>
                </form>
                <a class="mt-1" routerLink="/login">Voltar</a>
            </div>
        </div>
    </div>
</main>